<template>
  <div>
     <ProfessionalOrderSideView
       :isSidebarActive="professionalOrderSidebarActive"
      @closeSidebar="toggleSidebar"
      :data="professionalOrderSidebarData"
      @onProfessionalOrderUpdated="professionalOrderUpdated"
      @onProfessionalOrderInserted="professionalOrderInserted"
    />
    <vx-card ref="listCard" :title="$t('MRMR.ProfessionalOrder.Title')" title-color="black" refresh-content-action @refresh="getProfessionalOrders"> 
      <div id="data-list-list-view" class="data-list-container">
        <vs-table
          ref="professionalOrderTable"
          search
          :data="professionalOrders"
        >
          <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
            <vs-row vs-type="flex" vs-justify="space-between">
              <vs-col vs-type="flex" vs-justify="right" vs-align="center" vs-w="12">
                <feather-icon icon="PlusCircleIcon" class="cursor-pointer mr-5" svg-classes="h-6 w-6" @click="addProfessionalOrder" />
              </vs-col>
            </vs-row>
          </div>
          <template slot="thead">
            <vs-th>{{$t('Action')}}</vs-th>
            <vs-th sort-key="name">{{$t('MRMR.ProfessionalOrder.Name')}}</vs-th>
          </template>

          <template slot-scope="{data}">
            <tbody>
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td width="150px" class="whitespace-no-wrap">
                  <feather-icon
                    icon="EditIcon"
                    svgClasses="w-5 h-5 hover:text-primary stroke-current"
                    @click.stop="editProfessionalOrder(tr)"
                  />
                  <feather-icon
                    icon="TrashIcon"
                    svgClasses="w-5 h-5 hover:text-danger stroke-current"
                    class="ml-2"
                    @click.stop="openDeleteConfirm(tr.id)"
                  />
                </vs-td>
                <vs-td>
                  <p class="font-medium truncate">{{ tr.name }}</p>
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>
      </div>
    </vx-card>
  </div>
</template>
<script>

import moduleMRMR from "../../store/moduleMRMR.js";
import ProfessionalOrderSideView from "./components/professionalOrderSideView.vue"
export default {
  components: {
    ProfessionalOrderSideView
  },
  data() {
    return {
      selectedMainProjectId: null,
      professionalOrderSidebarActive: false,
      professionalOrderSidebarData: {}
    };
  },

  computed: {
    professionalOrders() {
      return this.$store.state.mrmr.professionalOrders;
    },
    mainProjectId() {
      return Number(this.$store.state.projectId);
    }
  },
  mounted() {
    if (this.$store.state.mrmr.projects.length === 0) {
      this.$vs.loading();

      this.$store.dispatch("mrmr/fetchAllProjects").then(() => {
        if (!this.isMounted) {
          this.$refs.listCard.refreshcard();
        }

        this.isMounted = true;
      }).finally(() => {
        this.$vs.loading.close();
      })
    } 
    else if (!this.isMounted) {
      this.$refs.listCard.refreshcard();
      this.isMounted = true;
    }
  },
  created() {
    if (!moduleMRMR.isRegistered) {
      this.$store.registerModule("mrmr", moduleMRMR);
      moduleMRMR.isRegistered = true;
    }
  },
  methods: {
    addProfessionalOrder() {
      this.professionalOrderSidebarData = {};
      this.toggleSidebar(true);
    },
    editProfessionalOrder(data) {
      this.professionalOrderSidebarData = data;
      this.toggleSidebar(true);
    },
    toggleSidebar(val = false) {
      this.professionalOrderSidebarActive = val;
    },
    professionalOrderUpdated() {
      this.$vs.notify({
        title: this.$t("Success"),
        text: this.$t("SaveSuccess"),
        color: "success",
        iconPack: 'feather',
        icon:'icon-check'
      });

      this.toggleSidebar(false);

    },

    professionalOrderInserted() {
      this.$vs.notify({
        title: this.$t("Success"),
        text: this.$t("InsertSuccess"),
        color: "success",
        iconPack: 'feather',
        icon:'icon-check'
      });
      this.toggleSidebar(false);
    },
  
    getProfessionalOrders() {
      this.$store.dispatch("mrmr/fetchProfessionalOrders").finally(() => {
        this.$refs.listCard.removeRefreshAnimation()
      });
    },

    openDeleteConfirm(professionalOrderId) {
      this.$deleteConfirmation({
        text: this.$t('MRMR.ProfessionalOrders.ConfirmDelete'),
        accept: () => this.deleteProfessionalOrder(professionalOrderId)
      });
    },

    deleteProfessionalOrder(id) {
      this.$store.dispatch("mrmr/removeProfessionalOrder", id)
        .then(() => {
          this.$notifyDeleteSuccess(this.$t("MRMR.ProfessionalOrders.ProfessionalOrderDeleted"));
          this.$refs.listCard.refreshcard();
        }).catch((error) => {
          if (error.response.status === 409) {
            this.$refs.listCard.refreshcard();
          }
        });
    }
  }
};
</script>
<style lang="scss">
#data-list-list-view {
.vs-con-table {
    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 0.8rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 8px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--tbody-table {
      min-width: 200px;
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
